import { render } from "./AccountPrivileges.vue?vue&type=template&id=54d21d3a&scoped=true"
import script from "./AccountPrivileges.vue?vue&type=script&lang=js"
export * from "./AccountPrivileges.vue?vue&type=script&lang=js"

import "./AccountPrivileges.vue?vue&type=style&index=0&id=54d21d3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d21d3a"]])

export default __exports__